import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";

import "swiper/css";

// Import Images
import img1 from "../Images/green1.jpg";
import img2 from "../Images/yellow5.jpg";
import img3 from "../Images/red5.jpg";
import img4 from "../Images/south7.jpeg";
import img5 from "../Images/yellowblue3.jpg";
import img6 from "../Images/blue1.jpg";
import img7 from "../Images/darkgreen1.jpg";
import img8 from "../Images/image39.png";
import img9 from "../Images/image33.png";
import img10 from "../Images/mix2.jpg";

function ProductCarousel() {

  // View All page navigation
  const navigate = useNavigate();

  const products = [
    { img1: img1, img2: img1, title: "All Women Dresses" },
    { img1: img2, img2: img2, title: "African Prints" },
    { img1: img3, img2: img3, title: "Traditional Wear" },
    { img1: img4, img2: img4, title: "Modern Styles" },
    { img1: img5, img2: img5, title: "Party Collection" },
    { img1: img6, img2: img6, title: "Casual Dresses" },
    { img1: img7, img2: img7, title: "Festival Wear" },
    { img1: img8, img2: img8, title: "Premium Outfits" },
    { img1: img9, img2: img9, title: "Summer Collection" },
    { img1: img10, img2: img10, title: "Winter Collection" },
  ];

  return (
    <>
      <section
        className="product-carousel"
        id="pro-caro1"
      >

        <Swiper
          modules={[Autoplay]}
          loop={true}
          spaceBetween={20}

          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}

          breakpoints={{
            0: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 5,
            },
          }}
        >

          {products.map((item, index) => (

            <SwiperSlide key={index}>

              <div className="product-card">

                <div className="img-box">

                  {/* MAIN IMAGE */}
                  <img
                    src={item.img1}
                    alt={item.title}
                    className="main-img"
                  />

                  {/* HOVER IMAGE */}
                  <img
                    src={item.img2}
                    alt={item.title}
                    className="hover-img"
                  />

                  {/* ICONS */}
                  <div className="icons">

                    <i className="fa-solid fa-heart"></i>

                    <i className="fa-solid fa-share"></i>

                    <i className="fa-solid fa-eye"></i>

                  </div>

                  {/* HOVER CONTENT */}
                  <div className="hover-content">

                    <h4>
                      {item.title}
                    </h4>

                    {/* EXPLORE COLLECTION */}
                    <button
                      type="button"
                      className="explore-btn"
                      onClick={() => navigate("/view-all")}
                    >
                      Shop Now
                    </button>

                  </div>

                </div>

              </div>

            </SwiperSlide>

          ))}

        </Swiper>

      </section>
    </>
  );
}

export default ProductCarousel;
